// @ts-nocheck
import { useState } from 'react';
import { Text } from '@mantine/core';
import CustomerChangeModal from '@/components/modals/customer-change-modal';
import SCCheckbox from '@/components/sc-controls/form-controls/sc-checkbox';
import * as Enums from '@/utils/enums';

const JobCustomerChange = ({ job, setShowChangeCustomer, callback }: any) => {

    const [transferAssets, setTransferAssets] = useState(true);

    const hasAssets = job.JobInventory?.filter((inv: any) => inv.IsActive && inv.ProductID).length > 0;

    return (
        <CustomerChangeModal
            open={true}
            onClose={() => setShowChangeCustomer(false)}
            itemLabel={job.JobCardNumber}
            moduleLabel="job"
            description="Changing the customer reassigns any related queries, quotes and invoices still in draft. You cannot change the customer when there are related quotes and invoices that are accepted."
            cannotChangePrefix="This job has quotes or invoices that are already accepted, invoiced, approved or paid."
            checkUrl={`/Job/JobCustomerChangeCheck?jobCardID=${job.ID}`}
            changeUrl="/Job/JobCustomerChange"
            itemIdKey="JobCardID"
            itemId={job.ID}
            moduleType={Enums.Module.JobCard}
            excludedCustomerID={job.CustomerID}
            onCustomerChanged={(result: any) => {
                setShowChangeCustomer(false);
                callback(result);
            }}
            extraPayload={(customer: any) => ({
                TransferAssets: transferAssets,
                ResetSignatures: customer?.ID !== job.Customer?.ID,
            })}
            renderExtra={({ selectedCustomer }: any) => (<>
                {hasAssets && (
                    <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                        <SCCheckbox
                            onChange={() => setTransferAssets(!transferAssets)}
                            value={transferAssets}
                            label="Transfer Assets"
                        />
                    </div>
                )}
                {selectedCustomer && selectedCustomer.ID !== job.Customer?.ID && (
                    <Text size="sm" mt="sm">Please note, customer&apos;s signature will be cleared</Text>
                )}
            </>)}
        />
    );
};

export default JobCustomerChange;
